// extracted by mini-css-extract-plugin
module.exports = {"selected":"DivisionComponent_selected__1-oXn","teamName":"DivisionComponent_teamName__1sBAD"};